import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import { selectPlan } from '@/store';

import { OrgPlaylistPreviewCarousel } from '../OrgPlaylistPreviewCarousel';
import { useSelectedEpisodesToolbar } from '../SelectedEpisodesToolbar';
import { EpisodeSearch } from './EpisodeSearch';

const referrer = {
  page: EVENT_CONSTANTS.PAGE.CONTENT_CURATION,
};

export const OrgPlaylistCreator = () => {
  const plan = useSelector(selectPlan);
  const { addEpisode } = useSelectedEpisodesToolbar();

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: 4 }}>
        Recommended by {plan?.data?.organizationName}{' '}
      </Typography>
      <Box sx={{ mb: 4 }}>
        <OrgPlaylistPreviewCarousel />
      </Box>
      <EpisodeSearch
        addEpisode={addEpisode}
        referrer={{ ...referrer, component: 'org_playlist_creator' }}
      />
    </Box>
  );
};
